import { getClustersFromDistMatWasm } from './clusterizerWasm';
onmessage = (event) => {
    const { distMatArray, n, methodCode } = event.data;
    const data = {};
    try {
        getClustersFromDistMatWasm(distMatArray, n, methodCode)
            .then((clusterMatrix) => {
            data.clusterMatrix = clusterMatrix;
            postMessage(data);
        }).catch((e) => {
            data.error = e;
            postMessage(data);
        });
    }
    catch (e) {
        data.error = e;
        postMessage(data);
    }
};
//# sourceMappingURL=clustering-worker.js.map